"use strict";
import s from "underscore.string";
import { renderTemplate } from "./templates";
import Api from "../api/api";
import "../api/account";
const LoadEmailCreator = function(loadState, carrierInvoice, user, subjectTemplateOverride, bodyTemplateOverride, templateVariables, carrier, renderOptions = {}) {
  const defaultSubjectTemplate = "{account_name} Questions{#if {invoice_number}} for Invoice {invoice_number}{#endif} on Load {load_id}: {exception_summary}";
  const defaultBodyTemplate = "Hi\n\nWe're seeing a few issues with load {load_id}:\n\n{exception_messages}\n\n{signature}\n";
  const bodyTemplateVariables = [
    "{account_name}",
    "{carrier_name}",
    "{invoice_number}",
    "{load_id}",
    "{order_id}",
    "{order_ids}",
    "{exception_messages}",
    "{signature}"
  ];
  const bodyTemplateVariablesForBroker = bodyTemplateVariables.concat([
    "{ship_date}",
    "{invoiced_amount}",
    "{expected_amount}",
    "{load_status}",
    "{variance_amount}",
    "{customer_charge}"
  ]);
  const bodyTemplateVariablesForFactor = bodyTemplateVariables;
  const getBodyTemplateVariables = () => Api.Account.matchAccountType({
    broker: () => bodyTemplateVariablesForBroker,
    factor: () => bodyTemplateVariablesForFactor,
    forwarder: () => bodyTemplateVariables
  });
  const buildSubject = () => {
    if (s.isBlank(subjectTemplateOverride)) {
      subjectTemplateOverride = defaultSubjectTemplate;
    }
    return renderTemplate(
      subjectTemplateOverride,
      templateVariables,
      user,
      loadState,
      [carrierInvoice],
      carrier,
      renderOptions
    );
  };
  return {
    initialEmail: function() {
      return {
        subject: buildSubject(),
        body: this.buildBody()
      };
    },
    buildBody: () => {
      if (s.isBlank(bodyTemplateOverride)) {
        bodyTemplateOverride = defaultBodyTemplate;
      }
      const bodyTemplateVariablesForAccount = getBodyTemplateVariables();
      return renderTemplate(
        bodyTemplateOverride,
        bodyTemplateVariablesForAccount,
        user,
        loadState,
        [carrierInvoice],
        carrier,
        renderOptions
      );
    }
  };
};
export default LoadEmailCreator;
